import type { Review } from "@/types/media";

function Stars({ rating }: { rating: number }) {
  const full = Math.round(rating / 2);
  return (
    <span className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`text-sm ${
            i < full ? "ri-star-fill text-accent-500" : "ri-star-line text-background-300"
          }`}
        ></i>
      ))}
    </span>
  );
}

export default function ReviewSection({ reviews }: { reviews: Review[] }) {
  return (
    <section className="mt-10">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <i className="ri-chat-quote-line text-primary-500"></i>
        影评摘要
      </h2>
      <p className="mt-1 text-sm text-foreground-500">
        以下为影迷评论演示内容，非真实数据
      </p>

      {reviews.length === 0 ? (
        <div className="mt-4 rounded-lg border border-dashed border-background-300 bg-background-50 py-10 text-center text-sm text-foreground-500">
          还没有影评，欢迎成为第一个分享观点的人。
        </div>
      ) : (
        <div className="mt-5 space-y-4">
          {reviews.map((r) => (
            <article
              key={r.id}
              className="rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-user-smile-line text-lg"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900">
                      {r.nickname}
                    </span>
                    <Stars rating={r.rating} />
                    <span className="text-xs font-semibold text-accent-600">
                      {r.rating.toFixed(1)}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{r.date}</span>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                {r.content}
              </p>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}